import React, { Fragment } from 'react';

const numericColumnWidth = '120';

const ColGroup = () => (
  <Fragment>
    <colgroup width="170" />
    <colgroup span={5}>
      <col width={numericColumnWidth} />
      <col width={numericColumnWidth} />
      <col width={numericColumnWidth} />
      <col width={numericColumnWidth} />
    </colgroup>
    <colgroup span={3} width="1*">
      <col />
      <col width={numericColumnWidth} />
      <col width={numericColumnWidth} />
    </colgroup>
  </Fragment>
);

export default ColGroup;
